'use client';

const getTextColor = ({
  emphasis,
  variant,
  disabled,
  onDark
}) => {
  if (disabled) {
    return onDark ? "onDark.disabled.muted" : "onLight.disabled.muted";
  }
  if (emphasis === "high") {
    const textColorsHigh = {
      default: "action.neutral.darkest",
      // a gap in design
      primary: onDark ? "onAction.primary.base" : "onAction.primary.dark",
      danger: onDark ? "action.neutral.darkest" : "action.destructive.lightest",
      upsell: onDark ? "action.neutral.darkest" : "action.upsell.lightest"
    };
    return textColorsHigh[variant];
  }
  const textColors = {
    default: onDark ? "action.neutral.lightest" : "action.neutral.darkest",
    primary: "onAction.primary.dark",
    // a gap in design
    danger: onDark ? "action.destructive.light" : "action.destructive.dark",
    upsell: onDark ? "action.upsell.light" : "action.upsell.dark"
  };
  return textColors[variant];
};
export {
  getTextColor
};
